export default __webpack_public_path__ + "static/media/README.bc7e57bb.md";